<template>
   <section class="page-section video-section" id="section2">
           
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-sm-12 col-lg-5">
                        <div class="text-wrap">
                            <div class="mb4">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>Home</b></p>
                                <h1>About Phase Two</h1>
                                <p class="mb2">Learn more details on phase two, including a timeline of progress, and an introduction to the Glider brand.</p>
                                 
                                <div class="video-box mb-4 hide-on-small-and-down show-on-medium-and-up">
                                  <!-- previous "glider" youtube video -->
                                  <!--
                                 <iframe width="100%" height="315" src="https://www.youtube.com/embed/25l1bzphFPo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                 -->
                                 <!-- <iframe src=https://player.vimeo.com/video/580210564 width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe> -->
                                  <!-- <video width="100%" height="auto" controls poster="@/assets/images/a141/video/JP_Thumbnail.png">
                                    <source type="video/mp4" 
                                      src="https://www.youtube.com/watch?v=25l1bzphFPo&t=5s">
                                  </video> -->
                                  <iframe style="height:350px;width:100%;" src="https://www.youtube.com/embed/X-cmERmoz_4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                   <!-- <object width="100%" height="349">
                                    <param name="movie" value="https://www.youtube.com/embed/X-cmERmoz_4" />
                                    <param name="allowFullScreen" value="true" />
                                    <param name="allowscriptaccess" value="always" />
                                    <embed type="application/x-shockwave-flash" width="100%" height="315" src="https://www.youtube.com/embed/X-cmERmoz_4" allowscriptaccess="always" allowfullscreen="true">
                                    </embed>
                                  </object> -->
                                </div>
                                 <div class="video-box mb-4 show-on-med-and-down hide-on-med-and-up">
                                   <!-- <iframe style="height:350px;width:560px" src="https://www.youtube.com/embed/X-cmERmoz_4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                                    <object width="560" height="349">
                                    <param name="movie" value="https://www.youtube.com/embed/X-cmERmoz_4" />
                                    <param name="allowFullScreen" value="true" />
                                    <param name="allowscriptaccess" value="always" />
                                    <embed type="application/x-shockwave-flash" width="100%" height="315" src="https://www.youtube.com/embed/X-cmERmoz_4" allowscriptaccess="always" allowfullscreen="true">
                                    </embed>
                                  </object>
                                  <!-- <object width="560" height="349">
                                    <param name="movie" value="https://www.youtube.com/embed/25l1bzphFPo" />
                                    <param name="allowFullScreen" value="true" />
                                    <param name="allowscriptaccess" value="always" />
                                    <embed type="application/x-shockwave-flash" width="100%" height="315" src="https://www.youtube.com/embed/25l1bzphFPo" allowscriptaccess="always" allowfullscreen="true">
                                    </embed>
                                  </object> -->
                                
                                </div>
                                <a href="/site/optionsPage" class="cta cta-bg-purple">Learn more</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12 col-lg-7">
                        <section class="page-section">
                              <div class="card-space boxes">
                                <div
                                  class="card two"
                                  v-for="(policy, index) in policies"
                                  :key="`policy_boxes_${index}`"
                                >
                                  <div
                                    :style="{
                                      backgroundImage:
                                        'url(' +
                                        require('@/assets/images/Belfast/Home/image' +
                                          (index + 1) +
                                          '.png') +
                                        ')',
                                    }"
                                  ></div>
                                  <div class="box-text-wrap">
                                    <h6> {{policy.title}}</h6>
                                    <p>{{ policy.Desc }}</p>
                                    <a :href="policy.link" >View more ></a>
                                  </div>
                                </div>
                              </div>
                           
                          </section>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
  name: "home-video-section",
  data() {
    return {
      policies: [
        {
          title: "What is Glider?",
          Desc: "Find out more information about Glider.",
          link:"/site/gliderPhasePage/j/glider-section"
        },
        {
          title: "Where are we now?",
          Desc:
            "View the timeline of the scheme to see what is happening currently and what will happen in the future.",
            link:"/site/gliderPhasePage/j/timeline-section"
        },
        {
          title: "Route Options",
          Desc: "Find out more information relating to the route options.",
          link:"/site/optionsPage"
        },
        {
          title: "Next steps",
          Desc: "Find out more information about the next steps of BRT2.",
          link:"/site/gliderPhasePage/j/next-steps-section"
        },
      ],
    };
  },
};
</script>
